export default "__VITE_ASSET__I9F7pSfF__"